export const coverageValidations = {
  // ==== Needed in case of future validations =====
  // liabilityRequestStatus: {
  //     oneOf: [2, 3],
  //     required: ["liabilityRequestEmail"],
  // },
};
